"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrDesktopNav = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const fdr_desktop_nav_menu_1 = require("./fdr-desktop-nav-menu");
const DesktopNavbar = styled_components_1.default.nav(({ theme }) => theme.menu.headerMenu || {}, (0, util_theme_sxc_1.sx2CssThemeFn)({
    display: ['none', 'flex'],
    flexDirection: ['column', 'row'],
    px: 3,
    ml: [null, 'auto'],
}));
const FdrDesktopNav = props => {
    const { className, menus, isSubMenuBlocked, onLinkClick, internalLinkIconName = `chevron-long-right`, } = props;
    return (react_1.default.createElement(DesktopNavbar, { className: className },
        react_1.default.createElement(fdr_desktop_nav_menu_1.FdrDesktopNavMenu, { menus: menus, internalLinkIconName: internalLinkIconName, isSubMenuBlocked: isSubMenuBlocked, onClick: onLinkClick })));
};
exports.FdrDesktopNav = FdrDesktopNav;
//# sourceMappingURL=fdr-desktop-nav.js.map